import script from "./expandable-item-card.vue?vue&type=script&setup=true&lang=js"
export * from "./expandable-item-card.vue?vue&type=script&setup=true&lang=js"

import "./expandable-item-card.vue?vue&type=style&index=0&id=d44823ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d44823ce"]])

export default __exports__